(function ($) {
  $.fn.scheduleList = function (options) {
    var self = this;


    var defaults = {

    };

    var settings = $.extend(true, {}, defaults, options);

    // Bind schedule show/hide functionality
    this.on('click', 'li .toggle a', function () {
      $(this).find('i').toggleClass('fa-square-o fa-square');

      var selected = $(this).find('i').hasClass('fa-square-o');
      var scheduleClass = $(this).data('schedule-id');
      self.trigger('scheduleClick', [scheduleClass, selected]);
    });

    this.on('mouseenter mouseleave', 'li', function () {
      $(this).find('.edit').toggleClass('hidden');
    });

    return this;
  };
}(jQuery));